import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';
import {
	GraphsFilterObject,
	LeadSourceStatisticItem,
	LeadSourceFullStatisticItem,
	ServerDataResponse
} from '@models/models';
import {
	LeadSourceItem,
	LeadSourcesTemplates
} from '@models/lead-sources.model';
import { tap } from 'rxjs/operators';
import { FileDownloadDataServiceProvider } from '@services/files/file-download-service/file-download.data.service';

@Injectable()
export class LeadSourcesDataService {
	private updateLeadSourcesEvent$: BehaviorSubject<
		boolean
	> = new BehaviorSubject<boolean>(false);

	constructor(
		private http: HttpClient,
		private fileDownloadService: FileDownloadDataServiceProvider
	) {}

	getLeadSourcesOverview(
		type: string,
		pageRequest
	): Observable<ServerDataResponse<LeadSourcesTemplates>> {
		const url = `/api/user/v1/lead-sources/overview/${type.toLowerCase()}`;
		return this.http.post(url, pageRequest) as Observable<
			ServerDataResponse<LeadSourcesTemplates>
		>;
	}

	getLeadSourcesList(): Observable<ServerDataResponse<Array<LeadSourceItem>>> {
		const url = '/api/user/v1/lead-sources/list';
		return this.http.get(url) as Observable<
			ServerDataResponse<Array<LeadSourceItem>>
		>;
	}

	getActiveLeadSourcesList(): Observable<
		ServerDataResponse<Array<LeadSourceItem>>
	> {
		const url = '/api/user/v1/lead-sources/list/active';
		return this.http.get(url) as Observable<
			ServerDataResponse<Array<LeadSourceItem>>
		>;
	}

	exportLeadSourceData(
		filters: GraphsFilterObject,
		fileType: 'xls' | 'csv',
		fileName: string
	): Observable<Object> {
		const url = `/api/user/v1/lead-sources/usage-details/export/${fileType}`;
		return this.http
			.post(url, filters, { responseType: 'blob', observe: 'response' })
			.pipe(
				tap((response: HttpResponse<Blob>): void =>
					this.fileDownloadService.saveFile(response, fileName, fileType)
				)
			) as Observable<Object>;
	}

	getLeadSourceGraphData(
		filters: GraphsFilterObject
	): Observable<ServerDataResponse<Array<LeadSourceStatisticItem>>> {
		const url = '/api/user/v1/lead-sources/statistic';
		return this.http.post(url, filters) as Observable<
			ServerDataResponse<Array<LeadSourceStatisticItem>>
		>;
	}

	getAllLeadSourcesStatisticData(
		filters: GraphsFilterObject
	): Observable<ServerDataResponse<Array<LeadSourceFullStatisticItem>>> {
		const url = '/api/user/v1/lead-sources/usage-details';
		return this.http.post(url, filters) as Observable<
			ServerDataResponse<Array<LeadSourceFullStatisticItem>>
		>;
	}

	sendAction(url: string, method: string, payload?): Observable<Object> {
		return this.http[method.toLowerCase()](url, payload);
	}

	get leadSourcesEventTrigger(): Observable<boolean> {
		return this.updateLeadSourcesEvent$.asObservable();
	}

	updateLeadSourcesEvent(state: boolean): void {
		this.updateLeadSourcesEvent$.next(state);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/lead-sources/lead-sources.data.service.ts